import React, { useState, useEffect } from "react";
import { Container, Label, Input, FormGroup, Col } from 'reactstrap';
import { Formik, Form, Field } from 'formik';
import { Loading } from '../../share/loading'
import * as Yup from 'yup'
import '../../share/form.css';
import Swal from 'sweetalert2'
import { useSearchParams, useNavigate } from "react-router-dom";
import { NumericFormat } from 'react-number-format';
// import Select from 'react-select';
import { GetVMdDept } from "../../share/api/MasterDataApi";
import { FormikSelect } from "../../share/FormikSelect";
import DataRegisterComponent from "../../share/DataRegisterComponent";

export function EntrepreneurAnnounce10InnovationFormComponent() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    let supportInnovationId = searchParams.get("req")
    let status = searchParams.get("status")
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    // ดึง cookie มาใช้
    const user = JSON.parse(localStorage.getItem("userData"))

    // state ดึงข้อมูลจาก master data
    const [deptsData, setDeptsData] = useState([]);
    const [titleName, setTitleName] = useState([]);
    // const [dataRegister, setDataRegister] = useState([]);
    // const [selectedOptions, setSelectedOptions] = useState();


    useEffect(() => {
        GetVMdDept({ setDeptsData, setLoading })
        GetTitleName()
        // getDataRegister()
        getDataInnovationforEdit()
    }, [])

    const CustomInput = React.forwardRef((props, ref) => {
        const { className, ...rest } = props;
        return (
            <Input
                {...rest}
                ref={ref}
                className={`rounded-pill text-center input-color ${className}`}
            />
        );
    });


    async function getDataInnovationforEdit() {

        if (searchParams.get("req") !== "0") {
            setLoading(true)
            let postData = new FormData()
            postData.append("supportInnovationId", supportInnovationId)
            try {
                let res = await fetch("api/Support/getDataInnovationForEdit/", {
                    method: "POST",
                    body: postData
                })
                let resJson = await res.json();
                await resJson.dataenum.map((item) => {
                    item["registerId"] = user.registerId;
                    item["status"] = searchParams.get("status")
                    item["supportInnovationId"] = searchParams.get("req")
                    item["customerTypeId"] = Number(user.roldId)
                    item = JSON.stringify(item).replace(/null/g, `""`);
                    item = JSON.parse(item);
                    setData((prev) => {
                        return { ...prev, ...item }
                    })
                });
            } catch (e) {
                // console.log("err", e)
            } finally {
                setLoading(false);
            }
        } else {
            return;
        }
    }




    async function GetTitleName() {
        const res = await fetch("/api/MasterData/getTitle")
        const data = await res.json()
        setTitleName(data.dataenum);
    }

    const initialValues = {
        status: status,
        supportInnovationId: supportInnovationId,
        registerId: user.registerId,
        announce: "10",
        deptId: "",
        supportTypeId: "8",
        customerTypeId: Number(user.roldId),
        customerNo: "",
        personalNo: "",
        businessType: "",
        employeeAmount: "",
        authoriseTitleId: "",
        authoriseName: "",
        authorisePersonalId: "",
        addressNo: "",
        moo: "",
        soi: "",
        street: "",
        provinceCode: "",
        amphurCode: "",
        tumbonCode: "",
        locationId: "",
        postCode: "",
        phone: "",
        mobile: "",
        fax: "",
        email: "",
        coordinateName: "",
        coordinatePhone: "",
        coordinateMobile: "",
        coordinateFax: "",
        coordinateEmail: "",

    }

    const onSubmit = async (values) => {
        // console.log(values)

        try {
            let res = await fetch("/api/Support/saveSupportInnovationForm", {
                method: "POST",
                headers: { "Content-type": "application/json" },
                body: JSON.stringify(values),
            });

            let resJson = await res.json();
            console.log("getSupportInnovationId", resJson.dataenum);

            if (resJson.status === 1) {
                if (searchParams.get("status") === "0") {
                    Swal.fire({
                        icon: "success",
                        title: "บันทึกข้อมูลสำเร็จ",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        text: "บันทึกข้อมูลต่อหรือไม่",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            return navigate(`/supporting/Form/DetailInnovationCourse?req=${resJson.dataenum}&&status=${searchParams.get("status")}`)
                        }
                    })
                } else {
                    Swal.fire({
                        icon: "success",
                        title: "อัพเดทข้อมูลสำเร็จ",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        text: "",
                        confirmButtonColor: "#0A66C2",
                        confirmButtonText: "ตกลง",
                    }).then((result) => {
                        if (result.isConfirmed) {
                            return navigate(`/supporting/Form/DetailInnovationCourse?req=${searchParams.get("req")}&&status=${searchParams.get("status")}`)
                        }
                    })
                }

            } else {
                Swal.fire({
                    icon: "error",
                    title: "บันทึกข้อมูลไม่สำเร็จ",
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    text: `เนื่องจาก ${resJson.message}`,
                    confirmButtonColor: "#0A66C2",
                    confirmButtonText: "ตกลง",
                });
            }
        } catch (e) {
            // console.log(e)
        }
    }

    const validationSchema = Yup.object().shape({
        deptId: Yup.string()
            .required("กรุณาเลือกหน่วยงานที่ยื่นคำขอ"),
        authoriseTitleId: Yup.string()
            .required("กรุณาเลือกคำนำหน้าชื่อ"),
        authoriseName: Yup.string()
            .required("กรุณากรอกชื่อ-สกุล"),
        authorisePersonalId: Yup.string().min(13, "เลขบัตรประจำตัวประชาชนต้องมีจำนวน 13 หลัก")
            .required("กรุณากรอกเลขบัตรประจำตัวประชาชน 13 หลัก"),
        employeeAmount: Yup.number()
            .typeError("จำนวนลูกจ้างต้องเป็นตัวเลขเท่านั้น")
            .required("กรุณากรอกจำนวนลูกจ้าง"), //จำนวนลูกจ้าง

        coordinateName: Yup.string().required("กรุณากรอกชื่อผู้ประสานงาน"),
        coordinatePhone: Yup.string()
            // .matches(/^[0-9]{10}$/, "เบอร์โทรศัพท์ต้องประกอบไปด้วยตัวเลข 10 หลักเท่านั้น")
            .required("กรุณากรอกเบอร์โทรศัพท์ผู้ประสานงาน"),
        coordinateMobile: Yup.string()
            // .matches(/^[0-9]{10}$/, "เบอร์โทรศัพท์ต้องประกอบไปด้วยตัวเลข 10 หลักเท่านั้น")
            .required("กรุณากรอกเบอร์โทรศัพท์มือถือผู้ประสานงาน"),
        coordinateFax: Yup.string(),
        // .matches(/^[0-9]{10}$/, "เบอร์โทรศัพท์ต้องประกอบไปด้วยตัวเลข 10 หลักเท่านั้น"),
        coordinateEmail: Yup.string()
            .email("รูปแบบอีเมลไม่ถูกต้อง")
            .required("กรุณากรอกอีเมลผู้ประสานงาน"),
    })

    return (
        <Formik
            initialValues={status === "0" ? initialValues : data}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            enableReinitialize
        >
            {({ setFieldValue, values, touched, errors, handleBlur, handleChange }) => {
                // console.log("errors", values)


                return (

                    <Container className="d-flex flex-column justify-content-center align-items-center mb-5">
                        {!loading ? (
                            <div className="form-border">

                                <Form className='p-5 mb-4'>

                                    <Label
                                        style={{ fontWeight: "bold" }}
                                        className='customer-type text-center px-5'
                                    >
                                        แบบขอรับความเห็นชอบหลักสูตรการฝึกอบรมฝีมือแรงงานเพื่อพัฒนาทักษะความรู้ให้แก่ลูกจ้าง
                                        เพื่อเป็นการสร้างสรรค์นวัตกรรมหรือนำเทคโนโลยีมาใช้ในการผลิตสินค้าหรือบริการ
                                    </Label>
                                    <Label className="mb-3 input-color">ข้อมูลผู้ขอเงินช่วยเหลือหรืออุดหนุน</Label>
                                    <DataRegisterComponent />

                                    <Label
                                        className="mb-3 input-color">
                                        กรุณากรอกข้อมูล
                                        <span
                                            className="require-input">
                                            *
                                        </span>
                                    </Label>
                                    {/* input เลือกหน่วยงานที่จะยื่นคำขอ */}
                                    <FormGroup className="mt-3">
                                        <Label
                                            for="dept">
                                            ยื่นคำขอที่
                                            <span className="require-input">*</span>
                                            {touched.deptId && errors.deptId ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.deptId}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>

                                            <Field
                                                name="deptId"
                                                component={FormikSelect}
                                                options={deptsData}
                                                placeholder={<div className="input-color text-center">กรุณาเลือกหน่วยงาน</div>}
                                            />
                                        </Col>
                                    </FormGroup>

                                    {/* ผู้กระทำการแทน คำนำหน้าและชื่อ */}
                                    <FormGroup row>
                                        <Label
                                            for="titleId">
                                            โดย (ผู้มีอำนาจกระทำการแทน/ผู้รับมอบอำนาจ)
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.authoriseTitleId && errors.authoriseTitleId ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {errors.authoriseTitleId}
                                                </span>
                                                : null
                                            }
                                            {touched.authoriseName && errors.authoriseName ?
                                                <span
                                                    className="text-left text-danger px-1">
                                                    {errors.authoriseName}
                                                </span>
                                                : null
                                            }

                                        </Label>
                                        <div className='d-flex justify-content-start '>
                                            <div className="flex-grow-1">
                                                <Input
                                                    className={touched.authoriseTitleId && errors.authoriseTitleId ?
                                                        "input-error rounded-pill rounded-end text-center input-color" : "rounded-pill rounded-end text-center input-color"
                                                    }
                                                    type="select"
                                                    name="authoriseTitleId"
                                                    id="authoriseTitleId"
                                                    onBlur={handleBlur}
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                    }}
                                                    value={values.authoriseTitleId}

                                                >
                                                    <option defaultValue={"คำนำหน้า"}>
                                                        คำนำหน้า
                                                    </option>
                                                    {titleName.map((title, i) => (
                                                        <option
                                                            key={title.titleCode}
                                                            value={title.titleCode}>
                                                            {title.titleThai}
                                                        </option>
                                                    ))}
                                                </Input>

                                            </div>

                                            <div className="w-75">
                                                <Input
                                                    className={touched.authoriseName && errors.authoriseName ?
                                                        "input-error rounded-pill rounded-start text-center input-color" : " rounded-pill rounded-start text-center input-color"
                                                    }
                                                    type="text"
                                                    name="authoriseName"
                                                    id="authoriseName"
                                                    placeholder='กรุณากรอกชื่อ-สกุล'
                                                    onBlur={handleBlur}
                                                    onChange={(e) => {
                                                        handleChange(e)
                                                    }}
                                                    value={values.authoriseName}
                                                />
                                            </div>

                                        </div>
                                    </FormGroup>

                                    {/* input บัตรประจำตัวประชาชน  */}
                                    <FormGroup>
                                        <Label
                                            for="authorisePersonalId">
                                            เลขบัตรประจำตัวประชาชน
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {errors.authorisePersonalId ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.authorisePersonalId}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>

                                            <Field name="authorisePersonalId">
                                                {({ field, meta, form: { setFieldValue, values } }) => (
                                                    <NumericFormat
                                                        // {...field}
                                                        // allowLeadingZeros
                                                        // decimalScale={2}
                                                        // isNumericString={true}
                                                        maxLength={13}
                                                        min={13}
                                                        displayType="number"
                                                        value={values.authorisePersonalId}
                                                        // format={(value) => value.toLocaleString()} 
                                                        onValueChange={(values, sourceInfo) => {
                                                            setFieldValue(field.name, values.value)
                                                            // console.log("registerNumber", values.value);

                                                        }}
                                                        customInput={CustomInput}
                                                        className={errors.authorisePersonalId ? "input-error" : ""}
                                                    />
                                                )}
                                            </Field>

                                        </Col>
                                    </FormGroup>

                                    {/* จำนวนลูกจ้าง */}
                                    <FormGroup className=''>
                                        <Label
                                            for="employeeAmount">
                                            จำนวนลูกจ้าง
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.employeeAmount && errors.employeeAmount ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.employeeAmount}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className={touched.employeeAmount && errors.employeeAmount ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="employeeAmount"
                                                id="employeeAmount"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                value={values.employeeAmount}
                                            />
                                        </Col>
                                    </FormGroup>

                                    {/* ชื่อผู้ประสานงาน */}
                                    <FormGroup>
                                        <Label
                                            for="contact">ชื่อผู้ประสานงาน
                                            <span
                                                className="require-input">
                                                *
                                            </span>
                                            {touched.coordinateName && errors.coordinateName ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.coordinateName}
                                                </span> : null
                                            }
                                            {touched.coordinatePhone && errors.coordinatePhone ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.coordinatePhone}
                                                </span> : null
                                            }
                                            {touched.coordinateMobile && errors.coordinateMobile ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.coordinateMobile}
                                                </span> : null
                                            }
                                            {touched.coordinateEmail && errors.coordinateEmail ?
                                                <span
                                                    className="text-left text-danger mx-1">
                                                    {errors.coordinateEmail}
                                                </span> : null
                                            }
                                        </Label>
                                        <Col>
                                            <Input
                                                className={touched.coordinateName && errors.coordinateName ?
                                                    "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                }
                                                type="text"
                                                name="coordinateName"
                                                id="coordinateName"
                                                onBlur={handleBlur}
                                                onChange={(e) => {
                                                    handleChange(e)
                                                }}
                                                value={values.coordinateName}
                                            />

                                        </Col>
                                        <div className="px-4 pt-4">
                                            <FormGroup row>
                                                <Label
                                                    for="coordinatePhone"
                                                    sm={2}
                                                >
                                                    โทรศัพท์
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinatePhone"
                                                        name="coordinatePhone"
                                                        type="text"
                                                        className={touched.coordinatePhone && errors.coordinatePhone ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values.coordinatePhone}

                                                    />
                                                </Col>

                                                <Label
                                                    for="coordinateMobile"
                                                    sm={2}
                                                >
                                                    โทรศัพท์มือถือ
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateMobile"
                                                        name="coordinateMobile"
                                                        type="text"
                                                        className={touched.coordinateMobile && errors.coordinateMobile ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values.coordinateMobile}

                                                    />
                                                </Col>
                                            </FormGroup>

                                            <FormGroup row>
                                                <Label
                                                    for="soi"
                                                    sm={2}
                                                >
                                                    โทรสาร
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateFax"
                                                        name="coordinateFax"
                                                        type="text"
                                                        className={touched.coordinateFax && errors.coordinateFax ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values.coordinateFax}

                                                    />
                                                </Col>

                                                <Label
                                                    for="coordinateEmail"
                                                    sm={2}
                                                >
                                                    อีเมล
                                                </Label>
                                                <Col sm={4}>
                                                    <Input
                                                        id="coordinateEmail"
                                                        name="coordinateEmail"
                                                        type="text"
                                                        className={touched.coordinateEmail && errors.coordinateEmail ?
                                                            "input-error rounded-pill text-center input-color" : "rounded-pill text-center input-color"
                                                        }
                                                        onBlur={handleBlur}
                                                        onChange={(e) => {
                                                            handleChange(e)
                                                        }}
                                                        value={values.coordinateEmail}
                                                    />
                                                </Col>
                                            </FormGroup>
                                        </div>
                                    </FormGroup>
                                    <hr />

                                    <div className='d-flex justify-content-end align-items-center mt-5'>
                                        <button
                                            type="submit"
                                            // disabled={!(isValid && dirty)}
                                            className='btn-blue px-4 w-25'
                                        >
                                            ถัดไป
                                        </button>
                                    </div>
                                </Form>

                            </div>

                        ) : (
                            <Loading />
                        )}

                    </Container>

                )
            }}

        </Formik>

    );

}
